import { render, staticRenderFns } from "./FormPartAddress.vue?vue&type=template&id=8960e0de&scoped=true"
import script from "./FormPartAddress.vue?vue&type=script&lang=js"
export * from "./FormPartAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8960e0de",
  null
  
)

export default component.exports